module.exports = __webpack_public_path__ + "img/tab_location.ffb60d89.svg";